import { tileHandler } from "../handlers/tileHandler.js";
import { mulberry32, getSeedHash } from "../utils/prng.mjs";
import { ELEMENT_NAMES } from "../assets/elements.js";



export class worldHandler {
    constructor() {
        this.worldCache = new Map();
        this.currentWorldId = null;
        
        this.initialWorlds = {
            "fire": { xPos: -1, yPos: 18 },
            "earth": { xPos: 13, yPos: 14 },
            "light": { xPos: 18, yPos: 2 },
            "wind": { xPos: 16, yPos: -6 },
            "cold": { xPos: 5, yPos: -17 },
            "water": { xPos: -8, yPos: -15 },
            "lightning": { xPos: -15, yPos: -7 },
            "dark": { xPos: -14, yPos: 11 },
        };
    }

    setupDefaultWorld() {
        // 1. If we already have a valid active world, just return it
        if (this.currentWorldId && this.worldCache.has(this.currentWorldId)) {
            return this.getActiveWorld();
        }

        // 2. If the cache has worlds but no active ID is set, default to the first one
        if (this.worldCache.size > 0) {
            this.currentWorldId = this.worldCache.keys().next().value;
            return this.getActiveWorld();
        }

        // 3. If there are NO worlds at all, pick a random predetermined world
        const worldKeys = Object.keys(this.initialWorlds);
        const randomElementKey = worldKeys[Math.floor(Math.random() * worldKeys.length)];
        const coords = this.initialWorlds[randomElementKey];
        
        // Construct the seed as "xPos-yPos" (e.g., "-1-18")
        const seed = `${coords.xPos}-${coords.yPos}`;
        
        // Generate the new world: seed is xPos-yPos, element is "all", tier is 1
        this.addWorld(seed, ELEMENT_NAMES, 1);
        
        return this.getActiveWorld();
    }

    addWorld(seed, elements, tier) {
        if (this.worldCache.has(seed)) {
            return seed;
        }
        const random = mulberry32(getSeedHash(seed));
        const genSeed = Math.floor(random() * (Math.pow(10, 16)));

        const newWorld = new tileHandler(seed, genSeed, elements, tier);
        
        this.worldCache.set(seed, newWorld);

        if (!this.currentWorldId) {
            this.currentWorldId = seed;
        }

        //console.log(newWorld);
        return seed;
    }

    getWorld(worldId) {
        return this.worldCache.get(worldId) || null;
    }

    setActiveWorld(worldId) {
        console.log(worldId);
        if (!this.worldCache.has(worldId)) {
            return;
        }
        this.currentWorldId = worldId;
        return this.getActiveWorld();

    }

    getActiveWorld() {
        return this.worldCache.get(this.currentWorldId) || null;
    }

    deleteWorld(worldId) {
        if (this.currentWorldId === worldId) {
            this.currentWorldId = null;
        }
        return this.worldCache.delete(worldId);
    }

    saveToData() {
    const worldData = [];
    for (const [id, handler] of this.worldCache.entries()) {
        worldData.push({
            worldId: id, // Explicitly match the cache key
            data: handler.saveToData()
        });
    }

    return {
        currentWorldId: this.currentWorldId,
        worlds: worldData
    };
}

loadFromData(data) {
    if (!data || !data.worlds || data.worlds.length === 0) return;

    this.worldCache.clear();
    
    data.worlds.forEach((entry) => {
        // Support either wrapped structure or direct serialized handler
        const id = entry.worldId || entry.seed;
        const handler = tileHandler.fromData(entry.data || entry);
        this.worldCache.set(id, handler);
    });

    // Fallback to first available world if currentWorldId isn't found
    this.currentWorldId = this.worldCache.has(data.currentWorldId)
        ? data.currentWorldId
        : this.worldCache.keys().next().value;
}
}